import { Project } from "../../models/project";
import ProjectEvents from "../events/ExProjectEvents";

// プロジェクト一覧取得開始
export const GetAllProjectList= (userId: string)=> ({
    type: ProjectEvents.GetAllProjectListStarted,
    userId
} as const);

// プロジェクトフィルター（プロジェクト一覧画面用）
export const filterProjectList = (id: string, filters: string[]) => ({
    type: ProjectEvents.filterProjectListStart,
    userId: id,
    filters
} as const);
export const filterProjectListComplete = (filterResult: Project[]) => ({
    type: ProjectEvents.filterProjectListComplete,
    filterResult
} as const);

// プロジェクト一覧取得完了
export const GetAllProjectListComplete = (projectList: Project[]) => ({
    type: ProjectEvents.GetAllProjectListComplete,
    projectList
} as const);

// プロジェクト一覧更新開始
export const UpdateProject = (userId: string, projectList: Project[]) => ({
    type: ProjectEvents.UpdateProjectStarted,
    userId,projectList
} as const);

// プロジェクト一覧更新完了
export const UpdateProjectComplete = (projectList: Project[]) => ({
    type: ProjectEvents.UpdateProjectComplete,
    projectList
} as const);

// プロジェクト一覧更新失敗
export const UpdateProjectFailed = (error: string) => ({
    type: ProjectEvents.UpdateProjectFailed,
    error
} as const);

// プロジェクトにビデオ（エビソード・関連）を追加
export const AddVideoToProject = (userId: string, projectId: string, videoId: string) => ({
    type: ProjectEvents.AddVideoToProject,
    userId, projectId, videoId
} as const);
export const AddVideoToProjectComplete = (project: Project) => ({
    type: ProjectEvents.AddVideoToProjectComplete,
    project
} as const);